<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.training-overview {
    position: relative;

    .filter-hero {
        position: relative;

        p {
            line-height: 2;
        }

        &:after {
            content: "";
            background-image: url("/svg/shapes/border-bottom-primary.svg");
            height: 58px;
            width: 100%;
            position: absolute;
            right: 0;
            bottom: -17px;
            overflow: hidden;

            @media screen and (min-width: $screen-sm) {
                background-size: cover;
                background-repeat: no-repeat;
                bottom: -56px;
            }

            @media screen and (min-width: 1441px) {
                height: 80px;
            }
        }

        @media screen and (min-width: 1441px) {
            min-height: 424px;
        }
    }

    .main-filter {
        .btn {
            padding-left: 64px;
            padding-right: 64px;
        }
    }
    .additional-filters.tags {
        .tag {
            background-color: $primary-opaque;
            color: $primary;
            label {
                font-size: 100%;
                margin-bottom: 0;
            }
            input[type="checkbox"] {
                display: none;
            }

            .checkbox {
                position: relative;
                padding-left: 32px;
                user-select: none;

                &:before {
                    display: block;
                    position: absolute;
                    left: 0;
                    margin-top: 1px;
                    width: 20px;
                    height: 20px;
                    content: "";
                    line-height: 1;
                    color: #fff;
                    padding-top: 1px;
                    padding-left: 4px;
                    border: 1px solid $input-border-color;
                    border-radius: 2px;
                    -webkit-transition: background-color 0.15s ease-in-out,
                        border-color 0.15s ease-in-out,
                        box-shadow 0.15s ease-in-out;
                    transition: background-color 0.15s ease-in-out,
                        border-color 0.15s ease-in-out,
                        box-shadow 0.15s ease-in-out;
                }

                &:hover {
                    cursor: pointer;

                    &:before {
                        border-color: $primary;
                    }
                }

                &.checked {
                    &:before {
                        content: url(/svg/checkmark.svg);
                        background-color: $primary;
                        border-color: $primary;
                    }
                }
            }
        }
    }
    .intro {
        a {
            color: $secondary;
        }
    }
}
</style>

<template>
    <div class="training-overview mb-80 mb-md-120 mb-lg-160">
        <div class="filter-hero bg-primary pt-40 pt-md-56 pt-lg-80 pt-xl-160 pb-40 pb-md-32 mb-56 mb-md-120">
            <div class="container">
                <div class="intro d-lg-flex mb-40 mb-lg-80">
                    <h1 class="h3 text-white">{{ trainingsPage.page_title }}</h1>
                    <div class="text-white font-weight-light text-cut ml-lg-80 mb-child-0" v-html="trainingsPage.content"></div>
                </div>

                <div class="main-filter d-lg-flex">
                    <div class="w-100 mb-16 mb-lg-0">
                        <v-select v-model="filter.province" :options="provinces" @input="clearCity" :placeholder="'Provincie'" :clearable="true"></v-select>
                    </div>
                    <div class="w-100 mb-16 mb-lg-0">
                        <v-select v-model="filter.city" :options="cities" @input="selectProvince" :placeholder="'Gemeente'" :clearable="true"></v-select>
                    </div>
                    <div class="w-100 mb-16 mb-lg-0">
                        <vue-date-picker v-model="dateRange" @input="setFilterDate" :min-date="minDate" :no-calendar-icon="true" name="Wanneer" placeholder="Wanneer" :no-header="true" :locale="locale" :fullscreen-mobile="true" color="#6DB19A" :range="true"></vue-date-picker>
                    </div>
                    <button class="btn btn-secondary btn-lg" @click="initiateSearch"><span>{{ translations.search }}</span></button>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="secondary-filter mb-40 mb-md-80">
                <div class="additional-filters tags float-md-right">
                    <div class="tag mb-8" @click.prevent=toggleOnline>
                        <input type="checkbox" id="online" v-model="filter.online" />
                        <label class="checkbox" :class="{'checked': filter.online}" for="online">{{ trainingsPage.online }}</label>
                    </div>
                    <div class="tag mb-8" @click.prevent=toggleELearning>
                        <input type="checkbox" id="e_learning" v-model="filter.e_learning" />
                        <label class="checkbox" :class="{'checked': filter.e_learning}" for="e_learning">{{ trainingsPage.e_learning }}</label>
                    </div>
                </div>
                <div class="tags mb-n8">
                    <span v-for="tag in shownTags" class="tag mb-8" :class="{'active': filter.tags.includes(tag.id)}" @click="() => toggleTag(tag.id)" :key="tag.id">{{ tag.name }}</span>
                    <span v-if="limitedTags && (tags.length - shownTags.length) > 0" @click="limitedTags = false" class="expander mb-8">+{{ tags.length - shownTags.length }}</span>
                </div>
            </div>

            <div ref="trainings" id="trainings" class="trainings row">
                <div v-for="training in filteredTrainings" :key="training.id" class="col-12 col-md-6 col-lg-4 col-xl-3 mb-32 mb-md-80">
                    <training-card :training="training" :is-member="isMember" :translations="translations"></training-card>
                </div>
                <div class="text-center w-100" v-if="filteredTrainings.length === 0">
                    <p class="large">{{ trainingsPage.no_results }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var scrollIntoView = require('scroll-into-view');
import vSelect from 'vue-select'
import VueDatePicker from '@components/ui/DatePicker';
import nlBe from '../../lang/nl-be'
import dayjs from 'dayjs'

export default {
    components: {
        vSelect,
        VueDatePicker
    },

    props: {
        trainings: {
            type: [Array, Object],
            required: true
        },
        trainingsPage: {
            type: Object,
            required: true
        },
        translations: {
            type: Object,
            required: true
        },
        tags: {
            type: Array,
            required: true,
        },
        locations: {
            type: Array,
            required: true,
        },
        isMember: {
            type: Boolean,
            required: true,
        }
    },

    data: vm => ({
        filter: {
            province: null,
            city: null,
            date: null,
            tags: [],
            e_learning: null,
            online: null,
        },
        dateRange: null,
        minDate: dayjs().toDate(),
        limitedTags: true,
        filteredTrainings: vm.trainings,
        page: 1,
        pageSize: parseInt(process.env.MIX_TRAINING_PAGE_SIZE || 50),
        locale: nlBe,
    }),

    mounted() {
        const setFilterByParameter = () => {
            const params = new URLSearchParams(location.search)

            this.filter.tags = params.getAll('tags[]');
            if (this.filter.tags.find(t => !this.shownTags.includes(t))) {
                this.limitedTags = false
            }
            if (params.get('date')) {
                this.filter.date = params.get('date')
                const [start, end] = params.get('date').split(',')
                this.dateRange = {
                    end,
                    start,
                }
            }
            this.filter.province = params.get('province')
            this.filter.city = params.get('city')
            this.filter.e_learning = params.get('e_learning') ? params.get('e_learning') === 'true' : null
            this.filter.online = params.get('online') ? params.get('online') === 'true' : null
        }

        window.addEventListener('scroll', () => {
            let trainings = this.$refs.trainings;
            if (!trainings) {
                trainings = document.getElementById('trainings');
            }
            if (trainings) {
                if (document.documentElement.scrollTop > trainings.offsetTop + trainings.clientHeight - window.innerHeight - 300) {
                    this.nextPage()
                }
            }
        })

        setFilterByParameter();
    },

    methods: {
        toggleTag(tagId) {
            const tags = this.filter.tags.slice()
            const index = this.filter.tags.findIndex(t => t === tagId)
            if (index >= 0) {
                tags.splice(index, 1)
            }
            if (index < 0) {
                tags.push(tagId)
            }
            this.filter.tags = tags.sort()

            this.fetchResults()
        },
        initiateSearch() {
            this.filter.tags = []
            this.page = 1
            this.filter.online = null
            this.fetchResults()
        },
        nextPage() {
            if (this.filteredTrainings.length < this.page * this.pageSize) {
                return
            }
            this.page += 1
            this.fetchResults(this.page)
        },
        fetchResults(page = 1) {
            this.populateSearchParams()

            const offset = (page - 1) * this.pageSize
            axios.get(route('training_search.index', { ...this.filter, offset: offset })).then(result => {
                if (offset === 0) {
                    this.filteredTrainings = result.data
                    return
                }
                this.filteredTrainings = [...this.filteredTrainings, ...result.data]
            })
        },
        populateSearchParams() {
            const params = new URLSearchParams()
            for (let param in this.filter) {
                if (this.filter[param] !== null) {
                    if (Array.isArray(this.filter[param]) && this.filter[param].length) {
                        this.filter[param].forEach(ai => {
                            params.append(`${param}[]`, ai)
                        })
                    }
                    if (!Array.isArray(this.filter[param]) && this.filter[param] !== false) {
                        params.set(param, this.filter[param])
                    }
                }
            }

            let newUrl = location.pathname
            if (params.toString()) {
                newUrl += `?${params}`
            }

            window.history.replaceState({}, '', newUrl);
        },
        setFilterDate(date) {
            this.filter.date = `${date.start},${date.end}`
        },
        selectProvince(value) {
            if (!value) {
                return
            }
            const location = this.locations.find(location => location.cities.includes(value))
            if (!location) {
                return
            }
            this.filter.province = location.province
        },
        clearCity() {
            this.filter.city = null
        },
        toggleELearning() {
            this.filter.e_learning = !this.filter.e_learning === true || null
            this.fetchResults()
        },
        toggleOnline() {
            this.filter.online = !this.filter.online === true || null
            if (this.filter.online) {
                this.filter.province = null
                this.filter.city = null
                this.filter.date = null
            }
            this.fetchResults()
        }
    },

    computed: {
        shownTags() {
            if (this.limitedTags) {
                return this.tags.slice(0, 5)
            }
            return this.tags
        },
        provinces() {
            return this.locations.map(location => location.province)
        },
        cities() {
            if (!this.filter.province) {
                return this.locations.map(location => location.cities).reduce((acc, val) => acc.concat(val), []).sort()
            }

            const location = this.locations.find((location) => location.province === this.filter.province)
            return location ? location.cities : []
        },
    }
}
</script>
